import { MutationTree } from 'vuex';
import { COURSE } from '../mutation_types';
import { ICOURSESTATE } from '../state.d';

const state: ICOURSESTATE = {
  chapter: {
    cid: sessionStorage.getItem('course_chapter_cid') || '',
  },
};

/* eslint-disable no-param-reassign */
const mutations: MutationTree<ICOURSESTATE> = {
  [COURSE.SET_COURSE_CHAPTER_CID]: (s, cid: string) => {
    s.chapter.cid = cid;
    window.sessionStorage.setItem('course_chapter_cid', cid);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
